import React from "react";
import { Link } from "react-router-dom";
import { Image } from "antd-mobile";
import { useHistory } from "react-router";

import homeDefaultImg from "../../images/menu_home_default.png";
import homeActiveImg from "../../images/menu_home_active.png";

import webtoonDefaultImg from "../../images/menu_webtoon_default.png";
import webtoonActiveImg from "../../images/menu_webtoon_active.png";

import movieDefaultImg from "../../images/menu_movie_default.png";
import movieActiveImg from "../../images/menu_movie_active.png";

import audioDefaultImg from "../../images/menu_audio_default.png";
import audioActiveImg from "../../images/menu_audio_active.png";

import novelDefaultImg from "../../images/menu_novel_default.png";
import novelActiveImg from "../../images/menu_novel_active.png";


const MyNavbar = (props) => {

  const active = props.active;

  return (
    <div
      style={{
        width: '88%',
        height: 'calc((11vw) + 20px)',
        maxHeight: '10vh',
        margin: 'auto',
        position: 'fixed',
        bottom: 10,
        left: 0,
        right: 0,
        backgroundImage: 'linear-gradient(black, black), linear-gradient(to right, green, purple)',
        backgroundOrigin: 'border-box',
        backgroundClip: 'content-box, border-box',
        border: 'double 5px transparent',
        borderRadius: 30
      }}
    >
      <div>
        <Link to={"/"}>
          <Image
            src={active === '/' ? homeActiveImg : homeDefaultImg}
            width="10%"
            heigh="auto"
            style={{
              borderRadius: 0,
              margin: "auto 10px",
              maxWidth: "9vh",
              position: 'absolute',
              top: '50%',
              left: '10%',
              transform: 'translate(-50%, -50%)'
            }}
          />
        </Link>
      </div>
      <div>
        <Link to={"/webtoon"}>
          <Image
            src={active === '/webtoon' ? webtoonActiveImg : webtoonDefaultImg}
            width="10%"
            heigh="auto"
            style={{
              borderRadius: 0,
              margin: "auto 10px",
              maxWidth: "9vh",
              position: 'absolute',
              top: '50%',
              left: '29%',
              transform: 'translate(-50%, -50%)'
            }}
          />
        </Link>
      </div>
      <Link to={"/movie"}>
        <div>
          <Image
            src={active === '/movie' ? movieActiveImg : movieDefaultImg}
            width="10%"
            heigh="auto"
            style={{
              borderRadius: 0,
              margin: "auto 10px",
              maxWidth: "9vh",
              position: 'absolute',
              top: '50%',
              left: '48%',
              transform: 'translate(-50%, -50%)'
            }}
          />
        </div>
      </Link>
      <div>
        <Link to={"/audio"}>
          <Image
            src={active === '/audio' ? audioActiveImg : audioDefaultImg}
            width="10%"
            heigh="auto"
            style={{
              borderRadius: 0,
              margin: "auto 10px",
              maxWidth: "9vh",
              position: 'absolute',
              top: '50%',
              left: '67%',
              transform: 'translate(-50%, -50%)'
            }}
          />
        </Link>
      </div>
      <div>
        <Link to={"/novel"}>
          <Image
            src={active === '/novel' ? novelActiveImg : novelDefaultImg}
            width="10%"
            heigh="auto"
            style={{
              borderRadius: 0,
              margin: "auto 10px",
              maxWidth: "9vh",
              position: 'absolute',
              top: '50%',
              left: '85%',
              transform: 'translate(-50%, -50%)'
            }}
          />
        </Link>
      </div>
    </div>
  );
};

export default MyNavbar;
